module.exports = __webpack_public_path__ + "static/media/Pause.44fb81a5.svg";